import { useQuery } from '@tanstack/react-query';
import { getDeliveryMetrics } from '../../services';
import type { DeliveryMetricsParams } from '../../types/deliveryMetrics';

export const deliveryMetricsKeys = {
  all: ['deliveryMetrics'] as const,
  dashboard: (params: DeliveryMetricsParams) =>
    [...deliveryMetricsKeys.all, 'dashboard', params] as const,
};

export interface UseDeliveryMetricsOptions {
  /**
   * Live-polling interval in milliseconds, or `false` to
   * disable polling (the default).
   * react-query's `refetchIntervalInBackground` is left at its default
   * (`false`), so a hidden/backgrounded tab does not keep polling.
   */
  pollMs?: number | false;
}

export function useDeliveryMetrics(
  params: DeliveryMetricsParams,
  { pollMs = false }: UseDeliveryMetricsOptions = {},
) {
  return useQuery({
    queryKey: deliveryMetricsKeys.dashboard(params),
    queryFn: () => getDeliveryMetrics(params),
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    // Keep the previous dashboard rendered while a filter change
    // fetches — otherwise the filter controls unmount into the loading
    // spinner on every keystroke (losing focus in the date inputs).
    placeholderData: (previousData) => previousData,
    refetchInterval: pollMs,
  });
}
